import '@/assets/fonts/materialdesignicons.min.css';
import '@/assets/styles/main.scss';
import '@/assets/styles/helper.scss';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import api from './api';
import vueMoment from 'vue-moment';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import cpcomponents from '@callperfect/cp_components';

// rsync -av -e 'ssh -p 37022' dist/ root@12.139.131.72:/var/www/dockloading3/
// axios.defaults.baseURL = 'http://dockloading4.jellco.com/api/v1/';
// axios.defaults.baseURL = 'http://localhost:9000/api/v1/';
// axios.defaults.baseURL = "http://localhost:9001/api/v1/";

Vue.use(cpcomponents);
Vue.use(vueMoment);
Vue.component('validation-observer', ValidationObserver);
Vue.component('validation-provider', ValidationProvider);

Vue.config.productionTip = false;

api.init();

Vue.prototype.$common = store.state.common;
store.dispatch('common/getWindowWidth');
window.onresize = () => store.dispatch('common/getWindowWidth');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
